module.exports = __webpack_public_path__ + "media/images/country_flags/az-16a8b9d560e54f25c44ef949edeb5c34.png";